import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import { History } from 'history';
import { Link } from 'UI-Dash-Commons-UI';

interface DocsPageContentLinkProps
{
    text: string,
    to: string,
    history: History,
}

const DocsPageContentLink: FunctionComponent<DocsPageContentLinkProps> = props =>
{
    return <DocsPageContentLinkWrapper {...props}/>;
};

export default DocsPageContentLink;

const DocsPageContentLinkWrapper = styled( Link )`
  font-size: inherit;
`;
